import { render, staticRenderFns } from "./FbStep.vue?vue&type=template&id=295438f0&scoped=true"
import script from "./FbStep.vue?vue&type=script&lang=js"
export * from "./FbStep.vue?vue&type=script&lang=js"
import style0 from "./FbStep.vue?vue&type=style&index=0&id=295438f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "295438f0",
  null
  
)

export default component.exports